// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gVhN","controls":"styles_controls__IQfzt","charLimit":"styles_charLimit__22WFv","input":"styles_input__1oNGR","send":"styles_send__3h0aS"};